import { QrCodeIcon, TypeIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Heading } from "@/components/ui/heading";
import type { LabelField } from "../types";

interface FieldPaletteProps {
  onAddField: (type: LabelField["type"]) => void;
}

export function FieldPalette({ onAddField }: FieldPaletteProps) {
  return (
    <div className="space-y-4">
      <Heading level={3}>Add Fields</Heading>

      <div className="grid grid-cols-2 gap-2">
        <Button
          variant="outline"
          onPress={() => onAddField("text")}
          className="flex flex-col items-center gap-2 h-16"
        >
          <TypeIcon size={20} />
          <span className="text-xs">Text</span>
        </Button>

        <Button
          variant="outline"
          onPress={() => onAddField("barcode")}
          className="flex flex-col items-center gap-2 h-16"
        >
          <QrCodeIcon size={20} />
          <span className="text-xs">Barcode</span>
        </Button>
      </div>
    </div>
  );
}
